import { Table, TableProps } from "antd";
import { ColumnTitleProps } from "antd/lib/table/interface";
import { clsx } from "clsx";
import { SvgIcon } from "./components/SvgIcon";
import classes from "./GenericTable.module.less";

export function GenericTable<T extends Record<string, any>>({
    className,
    columns,
    rowClassName,
    ...props
}: TableProps<T>) {
    const _className = clsx(className, classes.table);
    const _columns = columns?.map((col) => {
        if (col.sorter) {
            return {
                ...col,
                title: ({ sortColumns }: ColumnTitleProps<T>) => {
                    const sortOrder = sortColumns?.find((s) => s.column.key === col.key)?.order;
                    const sortDirections = col.sortDirections || ["ascend", "descend"];
                    const showUpArrow = sortDirections.includes("ascend");
                    const showDownArrow = sortDirections.includes("descend");

                    return (
                        <div className={classes.header}>
                            {col.title}
                            <div className={classes.sorter}>
                                {showUpArrow && (
                                    <SvgIcon
                                        name="up"
                                        size={12}
                                        color={sortOrder === "ascend" ? "#1890ff" : undefined}
                                    />
                                )}
                                {showDownArrow && (
                                    <SvgIcon
                                        name="down"
                                        size={12}
                                        color={sortOrder === "descend" ? "#1890ff" : undefined}
                                    />
                                )}
                            </div>
                        </div>
                    );
                },
            };
        }
        return col;
    });

    return (
        <Table<T>
            className={_className}
            columns={_columns}
            rowClassName={(record, index, indent) => {
                const _rowClassName =
                    typeof rowClassName === "function"
                        ? rowClassName(record, index, indent)
                        : rowClassName;
                return clsx(
                    _rowClassName,
                    (index + 1) % 2 === 0
                        ? [classes.evenRow, "GenericTableEvenRow"]
                        : [classes.oddRow, "GenericTableOddRow"]
                );
            }}
            {...props}
        />
    );
}
